import React, { useEffect, useState } from "react";
import axios from "axios";
import { baseUrl } from "./baseUrl";

const previewClass = (preview) => {
  if (!preview) {
    return "";
  }
  if (preview.order_blocked || preview.would_exceed_credit || preview.credit_alert === "red") {
    return " is-danger";
  }
  if (preview.credit_alert === "yellow") {
    return " is-warning";
  }
  return " is-ok";
};

export default function CreditCartPreviewBar({
  shopId,
  cartTotal = 0,
  existingOrderTotal = 0,
  currency = "",
}) {
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!shopId || cartTotal <= 0) {
      setPreview(null);
      return;
    }

    const timer = setTimeout(() => {
      setLoading(true);
      axios
        .get(`${baseUrl}/shops/${shopId}/credit-preview`, {
          params: {
            cart_total: cartTotal,
            existing_order_total: existingOrderTotal,
          },
        })
        .then((res) => {
          setPreview(res?.data?.data || null);
        })
        .catch(() => {
          setPreview(null);
        })
        .finally(() => {
          setLoading(false);
        });
    }, 350);

    return () => clearTimeout(timer);
  }, [shopId, cartTotal, existingOrderTotal]);

  if (!shopId || cartTotal <= 0 || loading || !preview?.has_credit_limit) {
    return null;
  }

  if (!preview.message && preview.after_order_remaining_label == null) {
    return null;
  }

  return (
    <div className={`credit-cart-preview${previewClass(preview)}`}>
      <div className="credit-cart-preview-row">
        <span>اعتبار باقی‌مانده</span>
        <strong>{preview.remaining_credit_label || "—"}</strong>
      </div>
      {preview.cart_delta > 0 && (
        <div className="credit-cart-preview-row">
          <span>افزایش با این سبد</span>
          <strong>{preview.cart_delta_label}</strong>
        </div>
      )}
      {preview.after_order_remaining_label && !preview.order_blocked && !preview.would_exceed_credit && (
        <div className="credit-cart-preview-row">
          <span>پس از ثبت</span>
          <strong>{preview.after_order_remaining_label}</strong>
        </div>
      )}
      {preview.credit_days_remaining != null && (
        <div className="credit-cart-preview-row credit-cart-preview-meta">
          <span>
            {preview.credit_days_remaining > 0
              ? `${preview.credit_days_remaining} روز مانده از اعتبار روزانه`
              : "اعتبار روزانه منقضی"}
          </span>
        </div>
      )}
      {preview.message && (
        <div className="credit-cart-preview-message">{preview.message}</div>
      )}
    </div>
  );
}
